const State = {
  noticeList: []
}

export default State
